
import swal from "sweetalert";
import axios from "axios";
import axiosClient from "../api/axios";

const GET_USER = "/user";
const register = (username, email, password) => {
	return axios.post(GET_USER + "signup", {
		username,
		email,
		password,
	});
};
const login = (credentials) => {
	try {
		axiosClient.post('/Accounts/Login', credentials).then(res => {
			if (typeof res.data !== 'string') {
				swal('Đăng nhập thành công', {
					buttons: false,
					timer: 2000,
					icon: 'success'
				})
				
				localStorage.setItem('token', res.data['token']);
				localStorage.setItem('ID', res.data['ID']);
				localStorage.setItem('Role', res.data['Role']);
				localStorage.setItem('UserName', res.data['UserName']);
				localStorage.setItem('FullName', res.data['FullName']);
				localStorage.setItem('Phone', res.data['Phone']);
				localStorage.setItem('Email', res.data['Email']);
				localStorage.setItem('Image', res.data['Image']);
				localStorage.setItem('Active', res.data['Active']);
				localStorage.setItem('DatabaseName', res.data['DatabaseName']);
				localStorage.setItem('SecurityCode', res.data['SecurityCode']);
				localStorage.setItem('ExpirationDate', res.data['ExpirationDate'])
				//window.location.href = '/';
				window.location.reload();

			}
			else {
				swal(res.data, {
					buttons: false,
					timer: 2000,
					icon: 'error'
				})
			}
		})
	}
	catch (error) {
		if (!error.response) {
			swal('Không có phản hồi từ server', error);
		}

	}
}
const logout = () => {
	localStorage.clear();
};

export default {
	register,
	login,
	logout
};
